import { TransferChannelType, TransferType } from "@/common/types";
import { MessagingInProgressActionButtons } from "./MessagingInProgressActionButtons";
import { closeEmailConversation } from "@/repository/queryFns";

export const EmailInProgressActionButtons = () => {
    return <MessagingInProgressActionButtons
        transferType={TransferType.EmailAgentTransfer}
        transferIVRType={TransferType.EmailAgentTransferToQueue}
        transferChannelType={TransferChannelType.Email}
        closeInteraction={closeEmailConversation}
        enablePauseButton
    />;
}